import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["srcset", "type"]
const _hoisted_2 = ["src"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PictureHelper',
  props: {
    imageName: null,
    rootUrl: { default: 'https://static.serato.com/visualizer/images/' },
    densities: null,
    formats: null
  },
  setup(__props: any) {

const props = __props as { imageName: string, rootUrl: string, densities: string[], formats: string[] };



const sources = computed(() => {
  let sources: Record<string, string> = {}
  for (const format of props.formats) {
    let sourceSet = ''
    for (const density of props.densities) {
      sourceSet += `${props.rootUrl}${props.imageName}-${density}.${format} ${density}, ` // e.g. "imagename-1x.webp 1x"
    }
    sources[format] = sourceSet
  }
  return sources
})

const fallbackSrc = computed(() => {
  const fallbackFormat = props.formats[props.formats.length-1] 
  return `${props.rootUrl}${props.imageName}-${props.densities[0]}.${fallbackFormat}`
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sources), (val, key, index) => {
      return (_openBlock(), _createElementBlock("source", {
        key: index,
        srcset: val,
        type: `image/${key}`
      }, null, 8, _hoisted_1))
    }), 128)),
    _createElementVNode("img", { src: _unref(fallbackSrc) }, null, 8, _hoisted_2)
  ]))
}
}

})